//Sticky Header
import $ from "jquery";
const stickyHeader = jQuery(".sticky-header");

window.onscroll = function () {
	if (window.scrollY >= window.innerHeight * 0.19) {
		stickyHeader.addClass("fixed");
	} else {
		stickyHeader.removeClass("fixed");
	}
};
